import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { AppService } from "src/_services/app.service";
import { Router } from "@angular/router";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatTableDataSource,
} from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-catalogue-auto-map",
  templateUrl: "./catalogue-auto-map.component.html",
  styleUrls: ["./catalogue-auto-map.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CatalogueAutoMapComponent implements OnInit {
  configsList = new MatTableDataSource<any>();
  isLoading = false;
  configsTableColumns = [
    "Category",
    "Status",
    "MaxLineDiff",
    "Enabled",
    "UpdatedAt",
    "Actions",
  ];

  constructor(
    private appService: AppService,
    private router: Router,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.configsList.filterPredicate = (data, filter: string) => {
      const category = (data.category || "").toLowerCase();
      const status = (data.status || "").toLowerCase();
      return category.includes(filter) || status.includes(filter);
    };
    this.getConfigs();
  }

  applyFilter(value: string) {
    this.configsList.filter = (value || "").trim().toLowerCase();
  }

  getStatusClass(status: string) {
    return (status || "").toUpperCase() === "ACTIVE"
      ? "status-active"
      : "status-blocked";
  }

  getConfigs() {
    this.isLoading = true;
    try {
      this.appService
        .getPremiumMarketAutoMapConfigs({ category: "" })
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.status === "RS_OK") {
              this.configsList.data = response.configs || [];
            } else {
              this.appService.openErrorBar(response.errorDescription);
              if (response.errorDescription === "Invalid Token!") {
                sessionStorage.clear();
                this.router.navigateByUrl("/login");
              }
            }
          },
          () => {
            this.isLoading = false;
            this.appService.openErrorBar("Failed to load auto map configs");
          }
        );
    } catch (err) {
      this.isLoading = false;
      console.log(err);
    }
  }

  addConfig = () => {
    const dialogRef = this.dialog.open(AddAutoMapConfig, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      width: "720px",
      data: {
        title: "Add Auto Map Config",
        add: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getConfigs();
      }
    });
  };

  editConfig = (element) => {
    const dialogRef = this.dialog.open(AddAutoMapConfig, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      width: "720px",
      data: {
        title: "Edit Auto Map Config",
        add: false,
        config: element,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getConfigs();
      }
    });
  };
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./add-auto-map.html",
  styleUrls: ["./add-auto-map.scss"],
})
export class AddAutoMapConfig implements OnInit {
  configForm: FormGroup;
  statuses = ["ACTIVE", "BLOCKED"];

  constructor(
    private fb: FormBuilder,
    private appService: AppService,
    public router: Router,
    public dialogRef: MatDialogRef<AddAutoMapConfig>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    const config = this.data.config || {};
    this.configForm = this.fb.group({
      category: [config.category || "", Validators.required],
      status: [config.status || "ACTIVE", Validators.required],
      maxLineDiff: [
        config.maxLineDiff != null ? config.maxLineDiff : 0,
        [Validators.required, Validators.min(0)],
      ],
      enabled: [config.enabled != null ? config.enabled : true],
    });

    if (!this.data.add) {
      this.configForm.get("category").disable();
    }
  }

  disable() {
    return this.configForm.invalid;
  }

  confirm() {
    if (this.disable()) {
      return;
    }

    const raw = this.configForm.getRawValue();
    const payload = {
      category: (raw.category || "").trim(),
      status: raw.status,
      maxLineDiff: Number(raw.maxLineDiff),
      enabled: !!raw.enabled,
    };

    const request = this.data.add
      ? this.appService.addPremiumMarketAutoMapConfig(payload)
      : this.appService.editPremiumMarketAutoMapConfig(payload);

    request.subscribe(
      (res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(
            this.data.add
              ? "Premium market auto map config added successfully"
              : "Premium market auto map config updated successfully"
          );
          this.dialogRef.close(true);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      },
      () => {
        this.appService.openErrorBar("Failed to save auto map config");
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
